<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { GeneralForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { GeneralProfileInterface } from '@/types';

const toast = useToast();

const profileStore = PersonStores.useUserProfileStore();

const route = useRoute();

const userId = parseInt(route.params.id as string, 10);

onBeforeMount(async () => await profileStore.setUser(userId));

const doToast = (error?: string) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? error : 'General information has been saved',
    life: 3000,
  });
};

const onSave = async (data: GeneralProfileInterface) => {
  await profileStore
    .updateGeneralInfo(data)
    .then(() => doToast())
    .catch((response) => doToast(response.data.message));
};
</script>

<template>
  <div>
    <GeneralForm :key="profileStore.id" :data="profileStore.general" :loading="profileStore.loading" @save="onSave" />
  </div>
</template>
